export var DEFAULT_MOBILE_PROPS = {
  columns: 1,
  rows: 1,
  stackable: true,
  displayAll: false
};
export var DEFAULT_TABLET_PROPS = {
  columns: null,
  rows: null,
  doubling: false,
  displayAll: false
};
export var DEFAULT_PAGINATION_PROPS = {
  display: true,
  onlyPageIndicators: false,
  defaultActivePage: 1
};